<template>
  <div class="information">
    <el-row :gutter="20">
      <el-col :span="12" :offset="6">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12" :offset="6">
              <el-form-item prop="avatar">
                <el-tooltip effect="light" placement="left">
                  <div slot="content">
                    最小尺寸 295*413 像素
                    <br />不大于200k <br />近期本人免冠一寸照片
                    <br />背景颜色为白色或淡蓝色
                    <br />着白色服装的请用淡蓝色背景
                    <br />其他颜色服装最好使用白色背景
                    <br />照片要求人像清晰，层次丰富，生态自然
                  </div>
                  <el-upload class="avatar-uploader" :headers="{ uploadType: 'phr_profile' }" :action="uploadUrl" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="ruleForm.avatarText" :src="ruleForm.avatarText" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="真实姓名" prop="realName">
            <el-input style="width: 100%" v-model="ruleForm.realName" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="realName">
            <el-input style="width: 100%" v-model="ruleForm.identityCard" placeholder="请输入身份证号" @input="cardWatch()"></el-input>
          </el-form-item>
          <el-form-item class="el-form-item-info-sex" label="性别" prop="gender">
            <el-radio-group v-model="ruleForm.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.birthday"
              style="width: 100%" :picker-options="pickerOptions0"></el-date-picker>
          </el-form-item>
          <el-form-item label="选择城市" prop="regionArr">
            <div class="block">
              <el-cascader style="width: 100%" id="el_cascader" placeholder="请选择城市" v-model="ruleForm.regionArr" :options="cityList" :props="SetKey"
                @change="handleChange"></el-cascader>
            </div>
          </el-form-item>
          <el-form-item label="所属医院" prop="hospitalName">
            <!-- <el-select style="width: 100%" v-model="ruleForm.hospitalId" filterable placeholder="请选择所属医院" no-data-text="请选择所属医院">
              <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select> -->
            <el-input v-model="ruleForm.hospitalName" @focus="doctorResult = true" placeholder="请选择医院">
            </el-input>
          </el-form-item>
          <el-form-item label="所属科室" prop="departmentName">
            <!-- <el-select style="width: 100%" v-model="ruleForm.departmentId" filterable placeholder="请选择所属科室" no-data-text="请选择所属科室">
              <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select> -->
            <el-input
              v-model="ruleForm.departmentName"
              @focus="departmentResult = true"
              placeholder="请选择科室"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="自我介绍" prop="intro">
            <el-input type="textarea" v-model="ruleForm.intro" class="input-textarea"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="loginBtn">
              <el-button style="width: 100%" v-if="ruleForm.status === 0 || ruleForm.status === -1" class="customBtn" type="primary"
                         @click="submitForm('ruleForm')">保存并下一步</el-button>
              <el-button style="width: 100%" v-else class="customBtn" type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
     <el-dialog :visible.sync="departmentResult" width="40%" center>
      <DepartmentList @on_disease_code="on_disease_code" />
    </el-dialog>
    <el-dialog :visible.sync="doctorResult" width="40%" center>
      <DoctorList @on_hosiptal_code="on_hosiptal_code" />
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils";
import {mapState} from 'vuex'

import {
  doctorEdit,
  getHospital,
  getCityList,
  getDoctorInfo,
} from "@/api/index.js";
import DepartmentList from "@/components/departmentList/DepartmentList.vue";
import DoctorList from "@/components/doctorList/DoctorList.vue";
export default {
  components:{
    DepartmentList,
    DoctorList
  },
  name: 'Information',
  props: {
    userData: Object,
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      Host: "http://doctor.ifarmiot.com/",
      hospitalList: "",
      departmentResult: false,
      SetKey: {
        value: "id",
        label: "title",
        children: "children",
      },
      genderList: [
        {
          label: "男",
          value: "1",
        },
        {
          label: "女",
          value: "2",
        },
      ],
      ruleForm: {
        // userName: "",
        // birthday: "",
        // hospitalId: "",
        // departmentId: "",
        // department: '',
        // hospital:'',
        // resource: "",
        // regionArr: [],
        // province_id: "",
        // city_id: "",
        // areaId: "",
        // intro: "",
        gender: "1",
        // avatar: "",
        // avatarText: "",
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 2,
            max: 8,
            message: "长度在 2 到 8 个字符",
            trigger: "blur",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        regionArr: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        avatar: [
          {
            required: true,
            message: "请上传头像",
            trigger: "change",
          },
        ],
        hospitalName: [
          {
            required: true,
            message: "请选择所属医院",
            trigger: "change",
          },
        ],
        departmentName: [
          {
            required: true,
            message: "请选择所属科室",
            trigger: "change",
          },
        ],
      },
      value: [],
      cityList: [],
      pickerOptions0: {  //elementUI不能选择超过当天的日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      departmentResult: false,
      doctorResult: false,
    };
  },
  computed:{
    ...mapState(['againChange'])
  },
  mounted() {
    // this.readyHospital();
    this.readyCityList();
    this.getUserInfo();
    this.$store.commit('updateActive', 1)
    
  },
  methods: {
    /**
     * 截取身份证信息
     */
    cardWatch() {
      let card = this.ruleForm.identityCard;
      if (card == undefined) return;
      if (card != "" && card.length == 15) {
        const year = `19${card.substr(6, 2)}`;
        const month = card.substr(8, 2);
        const day = card.substr(10, 2);

        var year_reg = /^(19|20)\d{2}$/;
        if (!year_reg.test(year)) {
          // this.$toast("身份证号码·年份·输入有误，无法读取生日");
          return;
        }
        if (month > 12) {
          // this.$toast("身份证号码·月份·输入有误，无法读取生日");
          return;
        }
        if (day > 31) {
          // this.$toast("身份证号码·日期·输入有误，无法读取生日");
          return;
        }
        const gender_code = card.substr(14, 1);
        if (gender_code % 2 == 0) {
          this.ruleForm.gender = "2";
        } else {
          this.ruleForm.gender = "1";
        }
        this.ruleForm.birthday = `${year}-${month}-${day}`;
        console.log(this.birthday, " this.birthday");
      } else if (card != "" && card.length == 18) {
        const year = card.substr(6, 4);
        const month = card.substr(10, 2);
        const day = card.substr(12, 2);

        var year_reg = /^(19|20)\d{2}$/;
        if (!year_reg.test(year)) {
          this.$toast("身份证号码·年份·输入有误，无法读取生日");
          return;
        }
        if (month > 12) {
          this.$toast("身份证号码·月份·输入有误，无法读取生日");
          return;
        }
        if (day > 31) {
          this.$toast("身份证号码·日期·输入有误，无法读取生日");
          return;
        }
        const gender_code = card.substr(16, 1);
        if (gender_code % 2 == 0) {
          this.ruleForm.gender = "2";
        } else {
          this.ruleForm.gender = "1";
        }
        this.ruleForm.birthday = `${year}-${month}-${day}`;
        console.log(this.ruleForm.birthday, " this.birthday");
      } else {
        this.ruleForm.gender = "";
        this.ruleForm.birthday = "";
      }
    },
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {
          id: util.getStore("user_id"),
        };
        let res = await getDoctorInfo(params);
        this.$store.commit('setProfileStep', res.result.profileStep);

        if (res.success) {
          this.ruleForm = res.result;
          this.ruleForm.gender = this.ruleForm.gender.toString();
          // const { username, birthday, regionArr, hospitalName, departmentName, intro, avatarText } = res.result;
          // const showUserInfo = { username, birthday, regionArr, hospitalName, departmentName, intro, avatarText }
          // this.ruleForm = showUserInfo;
          this.readyHospital(this.ruleForm.regionArr[2]);
          // this.readyDepartment(this.ruleForm.hospitalId);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @desc 获取所属城市
     */
    async readyCityList() {
      try {
        let res = await getCityList({});
        if (res.success) this.cityList = res.result;
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 保存信息
     */
    submitForm(formName) {
      //验证姓名是否符合真实姓名
      let regName = /^[\u4e00-\u9fa5]{2,4}$/;
      if (!regName.test(this.ruleForm.realName)) {
        this.$message({
          showClose: true,
          message: "请输入真实姓名",
        });
        return false;
      }
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            let res = await doctorEdit(this.ruleForm);
            if (res.success) {
              this.elementTips("success", res.message);
              this.getUserInfo();
              console.log(this.againChange);
              if (this.ruleForm.status === 0 || this.ruleForm.status === -1) {
                this.$router.push('/index/user/auditInformation/authentication')
              }
            } else {
              this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
              this.elementTips("warning", res.message);
            }
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    //建议搜索
    querySearch(queryString, cb) {
      var restaurants = this.departmentList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    //
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //选项点击方法
    handleSelect(item) {
      this.ruleForm.department = item.name;
      this.ruleForm.departmentId = item.id;
    },
    //城市点击方法
    handleChange(value) {
      this.ruleForm.regionId = value[2];
      this.ruleForm.hospitalId = "";
      this.ruleForm.departmentId = "";
      this.readyHospital(value[2]);
    },
    /**
     * 获取所属医院
     */
    async readyHospital(areaId) {
      try {
        const params = {
          areaId: areaId,
        };
        let res = await getHospital(params);
        if (res.success) {
          this.hospitalList = res.result;
          if (this.ruleForm.hospitalId == "") {
            this.ruleForm.hospitalId =
              this.hospitalList.length > 0 ? this.hospitalList[0].id : null;
          }
          if (this.hospitalList.length == "") {
            //当更换城市后所属科室设为空，重新选择
            this.ruleForm.departmentId = "";
          }
          // this.readyDepartment(this.ruleForm.hospitalId);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // //获取科室
    // async readyDepartment(hid) {
    //   try {
    //     const params = {
    //       hospitalId: hid,
    //     };
    //     let res = await getDepartment(params);
    //     if (res.success) {
    //       const result = res;
    //       this.departmentList = result.result.records;
    //       this.ruleForm.departmentId = this.ruleForm.departmentId
    //         ? this.ruleForm.departmentId
    //         : this.departmentList[0].id;
    //     } else {
    //       this.$message({
    //         showClose: true,
    //         message: res.message,
    //         type: "error",
    //       });
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    handleAvatarSuccess(res, file) {
      this.ruleForm.avatar = res.result.relativePath;
      this.ruleForm.avatarText = res.result.absolutePath;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "jpg";
      const isLt200k = file.size / 1024 < 200;

      if (!isJPG) {
        this.$message.error("头像图片格式错误");
      }
      if (!isLt200k) {
        this.$message.error("上传头像图片大小不能超过 200KB!");
      }
      return isJPG && isLt200k;
    },
    on_disease_code(data, type) {
      console.log(data, type);
      this.departmentResult = type;
      this.ruleForm.departmentId = data.id
      this.ruleForm.departmentName = data.name
    },
    on_hosiptal_code(data, type) {
      console.log(data, type);
      this.doctorResult = type;
      this.ruleForm.hospitalId = data.id
      this.ruleForm.hospitalName = data.name
    },
  },
};
</script>

<style lang="scss" scoped>
.information .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
span {
  background: black;
}

.information .avatar-uploader .el-upload:hover {
  // border-color: #409eff;
  border-color: #fc701a;
}

.information .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.information .avatar {
  width: 178px;
  height: 178px;
  border-radius: 50%;
  display: block;
}

/deep/.el-input__inner:focus {
  border: 1px solid #fc701a !important;
}
/deep/.el-textarea__inner:focus {
  border: 1px solid #fc701a !important; // 鼠标聚焦边框颜色
}
// /deep/ .el-cascader__dropdown.el-cascader-panel.el-cascader-menu.el-cascader-menu__wrap.el-cascader-menu__list.el-cascader-node.in-active-path.el-cascader-node__label {
//     color: #fc701a !important;

// }
// .el-cascader-node.in-active-path:focus{
//   color: #fc701a !important;
// }

// #el_cascader /deep/ :foucs {
//   color: #fc701a !important;
// }
// .el-date-table td.current:not(.disabled) span{
//   color:#fc701a !important;
// }

// /deep/
// .el-popper,.el-cascader__dropdown{
// .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
//   .el-cascader-panel{
//     .el-scrollbar,.el-cascader-menu{
//       .el-cascader-menu__wrap,.el-scrollbar__wrap{
//         .el-scrollbar__view,.el-cascader-menu__list{
//           .el-cascader-node.in-active-path{
//             .el-cascader-node__label :f{
//               color: #fc701a !important;

//             }
//           }
//         }
//       }
//     }
//   }
// }
// }
</style>
